import { FC } from 'react';
import { TooltipProps } from 'recharts';
import { Props } from 'src/types/motionGraph';
import { Colors } from 'src/utils/color';

import Chart, { LineChartProps } from './charts';
import { ChartContainer, Root } from './styles';

const lines = [
    {
        dataKey: 'afterBlinkFrameRemoval',
        strokeWidth: 3,
        name: 'afterBlinkFrameRemoval',
        stroke: Colors.motion_graph.legend,
        connectNulls: true
    }
];

// Custom tooltip to show x-y values
const CustomTooltip = ({ active, payload, label }: TooltipProps<number, string>) => {
    if (active && payload && payload.length > 0) {
        const data = payload[0].payload as any;
        const xValue = data?.time ?? label;
        const yValue = payload[0].value;
        
        return (
            <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                border: `1px solid ${Colors.motion_graph.axis}`,
                borderRadius: '6px',
                padding: '8px 12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                fontSize: '12px',
                fontFamily: '"Inter", sans-serif'
            }}>
                <div style={{ color: Colors.extra.dark_gray, marginBottom: '4px' }}>
                    Time: <strong style={{ color: Colors.extra.black }}>{typeof xValue === 'number' ? xValue.toFixed(3) : xValue}</strong> s
                </div>
                <div style={{ color: Colors.extra.dark_gray }}>
                    Value: <strong style={{ color: Colors.extra.black }}>{typeof yValue === 'number' ? yValue.toFixed(3) : yValue}</strong>
                </div>
            </div>
        );
    }
    return null;
};

const MotionGraph: FC<Props> = (props: Props) => {
    const { height, widthPercentage, yAxisLabel, xAxisLabel, data, showTooltip, onClick } = props;

    const dataAxisProps: LineChartProps<(typeof data)[number]>['axis'] = {
        x: {
            dataKey: 'time',
            type: 'category',
            allowDataOverflow: true
        }
    };
    return (
        <Root widthPercentage={widthPercentage} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
            <ChartContainer height={height} width={'100%'}>
                <Chart
                    data={data}
                    lines={lines}
                    axis={dataAxisProps}
                    xAxisLabel={xAxisLabel}
                    legend={{
                        hide: true
                    }}
                    gridOptions={{
                        hide: true
                    }}
                    tooltip={{
                        hide: !showTooltip,
                        content: showTooltip ? (props: any) => <CustomTooltip {...props} /> : undefined
                    }}
                    yAxisLabel={yAxisLabel}
                    height={height}
                />
            </ChartContainer>
        </Root>
    );
};

export default MotionGraph;
